export default __webpack_public_path__ + "assets/images/g-blocks-icon2-830b611e.svg";